import { IMAGES } from "./images";

export const RESOURCES = [
  {
    id: 1,
    title: "Complete Guide to Studying in Canada 2026",
    category: "Country Guide",
    excerpt:
      "Everything you need to know about admissions, visas, costs, and work opportunities in Canada for Indian students.",
    readTime: "12 min read",
    date: "March 2026",
    image: IMAGES.blogThumbnail,
  },
  {
    id: 2,
    title: "IELTS vs TOEFL: Which Test Should You Take?",
    category: "Test Prep",
    excerpt:
      "A detailed comparison of IELTS and TOEFL formats, scoring, acceptance, and preparation strategies for study-abroad aspirants.",
    readTime: "8 min read",
    date: "February 2026",
    image: IMAGES.blogThumbnail,
  },
  {
    id: 3,
    title: "How to Write a Winning Statement of Purpose",
    category: "Application Tips",
    excerpt:
      "Step-by-step guide to crafting an SOP that stands out, with real examples and common mistakes to avoid.",
    readTime: "10 min read",
    date: "February 2026",
    image: IMAGES.blogThumbnail,
  },
  {
    id: 4,
    title: "Top 10 Scholarships for Indian Students in 2026",
    category: "Scholarships",
    excerpt:
      "Discover fully-funded and partial scholarships available for Indian students across the USA, UK, Canada, and Australia.",
    readTime: "15 min read",
    date: "January 2026",
    image: IMAGES.blogThumbnail,
  },
  {
    id: 5,
    title: "Student Visa Interview: 25 Questions & How to Answer",
    category: "Visa Guide",
    excerpt:
      "Prepare for your visa interview with the most commonly asked questions and expert-approved answer frameworks.",
    readTime: "9 min read",
    date: "January 2026",
    image: IMAGES.blogThumbnail,
  },
  {
    id: 6,
    title: "Cost of Living: USA vs UK vs Canada vs Australia",
    category: "Finance",
    excerpt:
      "Compare tuition fees, rent, food, transport, and part-time work earnings across the top study-abroad destinations.",
    readTime: "11 min read",
    date: "December 2025",
    image: IMAGES.blogThumbnail,
  },
];

export const CASE_STUDIES = [
  {
    title: "From Rejection to Toronto — Priya's Journey",
    description:
      "After a visa rejection, Priya secured her MS admission at University of Toronto with a ₹5 lakh scholarship.",
    route: "/scholarship",
    image: IMAGES.caseStudy,
  },
  {
    title: "First-Gen Student Lands at King's College London",
    description:
      "Ananya became the first in her family to study abroad, thanks to our end-to-end Elite package support.",
    route: "/visa",
    image: IMAGES.caseStudy,
  },
  {
    title: "Vikram's Second-Chance Visa Success",
    description:
      "Reapplication strategy and mock interviews helped Vikram get his USA student visa after an initial denial.",
    route: "/visa",
    image: IMAGES.caseStudy,
  },
];

export const GUIDE_CARDS = [
  {
    title: "Choose Your Destination",
    description:
      "Compare countries by education quality, costs, work rights, and PR pathways to find your perfect fit.",
    route: "/resources",
  },
  {
    title: "Prepare Your Application",
    description:
      "University shortlisting, SOP writing, document preparation, and application filing — all in one place.",
    route: "/services",
  },
  {
    title: "Plan Your Departure",
    description:
      "Visa, accommodation, flights, SIM cards, and pre-departure checklist to ensure a smooth transition.",
    route: "/pricing",
  },
];
